import './index.scss';

import { Component } from 'react';
import { BraxModal } from '../BraxModal';

export type BraxLoadingProps = {
    modal: boolean,
    overlay: boolean,
    progress?: number
};

export class BraxLoading extends Component<BraxLoadingProps> {

    static defaultProps = {
        modal: true,
        overlay: true
    };

    render() {
        const progress = this.props.progress !== undefined ? Math.max(0, Math.min(this.props.progress, 100)).toFixed(1) : null;

        const loading = (
            <div className="brax-loading">
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />

                { progress ? (
                    <span>{ progress === '100.0' ? 100 : progress }%</span>
                ) : null }
            </div>
        );

        return this.props.modal ? (
            <BraxModal className="brax-loading-modal" overlay={this.props.overlay} backdrop={false} close={false}>
                { loading }
            </BraxModal>
        ) : loading;
    }

}
